export default "__VITE_ASSET__CVwb9chA__"